import clsx from 'clsx';
import { StaticImageData } from 'next/image';
import { AnimationEvent, CSSProperties, ReactNode } from 'react';
import screen01 from '../../assets/images/app-screens/app-screen-01.webp';
import screen02 from '../../assets/images/app-screens/app-screen-02.webp';
import screen03 from '../../assets/images/app-screens/app-screen-03.webp';
import screen04 from '../../assets/images/app-screens/app-screen-04.webp';
import screen05 from '../../assets/images/app-screens/app-screen-05.webp';
import { CSS_VAR_ANIMATION_DELAY } from '../../constants/css';
import { ScreenType } from '../../types/screen-type';
import { Badge } from '../Badge/Badge';
import { Image } from '../Image/Image';
import styles from './AppScreen.module.scss';

export type AppScreenProps = {
  screen: ScreenType;
  badge?: ReactNode;
  delay?: number;
  className?: string;
  onAnimationEnd?: (event: AnimationEvent<HTMLDivElement>) => any;
};

export const AppScreen = ({
  screen,
  badge,
  delay,
  className,
  onAnimationEnd = () => null,
}: AppScreenProps) => {
  const width = 280;
  const height = 605;

  const classes = clsx(styles.base, className);

  const style = {
    [CSS_VAR_ANIMATION_DELAY]: `${delay}ms`,
  } as CSSProperties;

  const props = getImageProps(screen);
  return (
    <div
      className={classes}
      style={style}
      onAnimationEnd={(event) => onAnimationEnd(event)}
    >
      {!!badge && (
        <Badge corner={'right'} className={styles.badge}>
          {badge}
        </Badge>
      )}
      <Image width={width} height={height} src={props.src} alt={props.alt} />
    </div>
  );
};

function getImageProps(screen: ScreenType): {
  src: StaticImageData;
  alt: string;
} {
  switch (screen) {
    case 'welcome':
      return { src: screen01, alt: 'easyGo app welcome screen' };
    case 'map':
      return { src: screen02, alt: 'easyGo app map screen' };
    case 'car':
      return { src: screen03, alt: 'easyGo app car dashboard screen' };
    case 'cost':
      return { src: screen04, alt: 'easyGo app cost dashboard screen' };
    case 'flexibleTariff':
      return { src: screen05, alt: 'easyGo app Flexible Tarife' };
  }
}
